module.exports = "/dist/roboto-latin-700.svg?7f57c4c0f3b44acbe338d7ff6d6ee5b1";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700.svg
// module id = 92
// module chunks = 0